import { Injectable } from '@angular/core';
import {RitornoPaginazione} from "../shared/models/RitornoPaginazione";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {ApiPathsService} from "../api-paths.service";
import {Acquisto, Container, Filter, Scorta, Spedizione, VoceAcquisto, VoceContainer, VoceSpedizione} from "./_Models";
import {Observable} from "rxjs";
import {ClassicType} from "../shared/models/ClassicType";

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {

  constructor(
    private http: HttpClient,
    private apiPaths: ApiPathsService,
  ) { }
  //#region acquisti
  PrimaNotaAcquistiStati(){
    return this.http.get<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/primanota/acquisti/stati`,
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaAcquistiStatiVoci(){
    return this.http.get<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/primanota/acquisti/stati/voci`,
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaAcquistiList(filter: Filter){
    return this.http.post<RitornoPaginazione<Acquisto[]>>(
      `${this.apiPaths.getBaseAPI()}/primanota/acquisti/list`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaAcquistiVoci(filter: Filter){
    return this.http.post<RitornoPaginazione<VoceAcquisto[]>>(
      `${this.apiPaths.getBaseAPI()}/primanota/acquisti/voci`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaAcquistiVoceGet(filter){
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/primanota/acquisti/voce/get`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaAcquistiGet(val){
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/primanota/acquisti/get`,
      JSON.stringify(val),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaAcquistiAdd(value: Acquisto): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/acquisti/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaAcquistiUpdate(value: Acquisto): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/acquisti/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaAcquistiDelete(value: Acquisto): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/acquisti/delete `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  ProdottiListinoProdottiGet(val){
    return this.http.post<RitornoPaginazione<any>>(
      `${this.apiPaths.getBaseAPI()}/prodotti/listino/prodotti/get`,
      JSON.stringify(val),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaAcquistiVoceUpdate(value: VoceAcquisto): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/acquisti/voce/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaAcquistiProdotti(filter: Filter){
    return this.http.post<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/primanota/acquisti/prodotti`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  //#endregion
  //#region stock
  PrimaNotaStockAdd(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/stock/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaStockUpdate(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/stock/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaStockDelete(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/stock/delete `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimanotaStockConflitti(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/stock/conflitti `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  //#endregion
  //#region produzione
  PrimaNotaProduzioneAdd(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/produzione/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaProduzioneUpdate(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/produzione/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaProduzioneDelete(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/produzione/delete `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimanotaProduzioneConflitti(value){
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/produzione/conflitti `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
//#endregion
  //#region spedizioni
  PrimaNotaSpedizioniStati(){
    return this.http.get<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/primanota/spedizioni/stati`,
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaSpedizioniList(filter: Filter){
    return this.http.post<RitornoPaginazione<Spedizione[]>>(
      `${this.apiPaths.getBaseAPI()}/primanota/spedizioni/list`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaSpedizioniVoci(filter: Filter){
    return this.http.post<RitornoPaginazione<VoceSpedizione[]>>(
      `${this.apiPaths.getBaseAPI()}/primanota/spedizioni/voci`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaSpedizioniGet(val){
    return this.http.post<Spedizione>(
      `${this.apiPaths.getBaseAPI()}/primanota/spedizioni/get`,
      JSON.stringify(val),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaStockProdotti(Filtri: Filter) {
    return this.http.post<VoceAcquisto[]>(
      `${this.apiPaths.getBaseAPI()}/primanota/stock/prodotti`,
      JSON.stringify(Filtri),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaSpedizioniAdd(value: Spedizione): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/spedizioni/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaSpedizioniUpdate(value: Spedizione): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/spedizioni/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaSpedizioniDelete(value: Spedizione): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/spedizioni/delete `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  //#endregion
  //#region Container
  PrimaNotaContainerStati(){
    return this.http.get<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/primanota/container/stati`,
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaContainerList(filter: Filter){
    return this.http.post<RitornoPaginazione<Container[]>>(
      `${this.apiPaths.getBaseAPI()}/primanota/container/list`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaContainerVoci(filter: Filter){
    return this.http.post<RitornoPaginazione<VoceContainer[]>>(
      `${this.apiPaths.getBaseAPI()}/primanota/container/voci`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaContainerGet(val){
    return this.http.post<Container>(
      `${this.apiPaths.getBaseAPI()}/primanota/container/get`,
      JSON.stringify(val),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaContainerAdd(value: Container): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/container/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaContainerUpdate(value: Container): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/container/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaContainerDelete(value: Container): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/container/delete `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaContainerVoceUpdate(value: VoceContainer): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/container/voce/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaContainerVoceMove(value: VoceContainer): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/container/voce/move `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  //#endregion
  //#region Scorte
  PrimaNotaScorteList(filter){
    return this.http.post<Scorta>(
      `${this.apiPaths.getBaseAPI()}/primanota/scorte/list`,
      JSON.stringify(filter),
      this.apiPaths.options()).pipe(map((data) => {
      return data;
    }));
  }
  PrimaNotaScorteAdd(value): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/scorte/add `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  PrimaNotaScorteUpdate(value): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/primanota/scorte/update `,
      JSON.stringify(value),
      this.apiPaths.options()).pipe();
  }
  //#endregion

  stampaSpedizioni(param: { ids: number[] }): Observable<any> {
      return this.http.post(`${this.apiPaths.getBaseAPI()}/primanota/spedizioni/print `,
        JSON.stringify(param),
        { headers: this.apiPaths.headers(),observe:'response',responseType:'blob'}).pipe();
  }
}
